import { DispositionsFormType } from '@mark43/cad-api';

export const UPDATE_DISPOSITION_DEFAULT_FORM_VALUES: DispositionsFormType = {
    agencyEventId: null,
    requestingUnitId: null,
    isRequestingUnitPrimaryUnit: false,
    primaryDisposition: null,
    primaryUnitIdFromAgencyEvent: null,
    primaryUnitCallSignFromAgencyEvent: null,
    primaryUnitIdFromDisposition: null,
    primaryUnitCallSignFromDisposition: null,
    additionalDispositions: [],
    comments: '',
};

export const CLEAR_EVENT_DEFAULT_FORM_VALUES = {
    eventId: null,
    primaryDisposition: null,
    additionalDispositions: [],
    comments: '',
};
